import Head from 'next/head';
import { Container } from 'react-bootstrap';

import { LocationIcon, MailIcon, PhoneIcon } from 'components/Icons';
import { Card, CircleIcon } from 'components/Layout';
import PrintHtml from 'components/PrintHtml/PrintHtml';
import { IContact } from 'services/contactService';

import s from '../style/pages/contact-us.module.scss';

interface IProps {
  contact: IContact;
}

function ContactUs({ contact = {} as IContact }: IProps) {
  return (
    <>
      <Head>
        <title>Contact us</title>
        <meta name="title" content="Contact us" />
        <meta name="description" content="Contact us" />
        <meta
          name="keywords"
          content="Atlas Insurance, contact us, Atlas Insurance contact us"
        />
      </Head>

      {contact ? (
        <Container className={s.items}>
          <Card className={s.item}>
            <div className="text-center">
              <CircleIcon className="mt-n5 mx-auto mb-4">
                <PhoneIcon size={3} fill="white" />
              </CircleIcon>

              <span className="font-weight-bold my-3 my-md-4">Telephone</span>
            </div>

            <PrintHtml content={contact.phone} />
          </Card>

          <Card className={s.item}>
            <div className="text-center">
              <CircleIcon className="mt-n5 mx-auto mb-4">
                <MailIcon size={3} fill="white" />
              </CircleIcon>

              <span className="font-weight-bold my-3 my-md-4">Email</span>
            </div>

            <PrintHtml content={contact.email} />
          </Card>

          <Card className={s.item}>
            <div className="text-center">
              <CircleIcon className="mt-n5 mx-auto mb-4">
                <LocationIcon size={3} fill="white" />
              </CircleIcon>

              <span className="font-weight-bold my-3 my-md-4">
                Postal address
              </span>
            </div>

            <PrintHtml content={contact.address} />
          </Card>
        </Container>
      ) : (
        ''
      )}
    </>
  );
}

export async function getServerSideProps() {
  return {
    props: {
      title: 'Contact us',
      backgroundImage: '/images/review3.jpg',
      contact: {
        phone: '<p style="text-align:center">+61 7 3130 0999</p>',
        email:
          '<p style="text-align:center"><a href="mailto:info@april9.com.au">info@april9.com.au</a></p>',
        address: `
          <p><strong>Brisbane (Head Office)</strong><br/>Level 4, South Tower, 339 Coronation Drive, Milton QLD 4064</p>
          <p><strong>Sydney</strong><br/>50 Clarence St, Sydney NSW 2000</p>
          <p><strong>Melbourne</strong><br/>220 Collins St, Melbourne VIC 3000</p>
        `,
      },
    },
  };
}

export default ContactUs;
